'use client'

import { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'

export default function MoreDatesButtonMobile(props: {
  searchWizard: boolean
  label: ReactNode
  additionalClassName?: string
  width?: string
  onClick?: () => void
  disabled?: boolean
}): ReactElement {
  return (
    <button
      onClick={!props.disabled ? props.onClick : undefined}
      className={classNames(props.additionalClassName, {
        'wm:rounded-0 wm:border-black-24 wd:hidden wm:mx-10 wm:mb-5 wm:mt-6 wm:h-auto wm:rounded-md wm:border-2 wm:px-2 wm:py-3 wm:font-semibold wm:text-stone-600':
          props.searchWizard,
        'wm:w-full': props.searchWizard && !props.width,
        'wml:rounded-0 wml:border-black-24 wdl:hidden wml:mx-10 wml:mb-5 wml:mt-6 wml:h-auto wml:rounded-md wml:border-2 wml:px-2 wml:py-3 wml:font-semibold wml:text-stone-600':
          !props.searchWizard,
        'wml:w-full': !props.searchWizard && !props.width,
        'opacity-50': props.disabled,
      })}
    >
      {props.label}
    </button>
  )
}
